
import { defineComponent } from 'vue';
import ClaimTable from '../../../../components/Service/Claim/ClaimTable.vue';
import ClaimDialog from '../../../../components/Service/Claim/ClaimDialog.vue';
export default defineComponent({
  components: { ClaimTable, ClaimDialog },
});
